<template>
  <el-main>
    <themes />
  </el-main>
</template>

<script>
  // components
  import Themes from './themes/Themes.vue';

  export default {
    name: 'PageContent',
    components: {
      Themes
    },
  }
</script>
